import { BackgroundColors } from '@picsart/design-system/foundation/colors';

import { createUseStyles } from 'react-jss';

import { isLeftToRight, isRightToLeft } from '@picsart/design-system/foundation/styleHelpers';
// import { BreakPointsMedia } from '@picsart/design-system/foundation/responsive';
import { Spacings } from '@picsart/design-system/foundation/spacings';

const useTemplateStyles = createUseStyles(
  {
    mainLayout: {
      // replace with [BreakPointsMedia.SM], [BreakPointsMedia.XS], [BreakPointsMedia.XXS]{
      '@media screen and (max-width: 1024px)': {
        '&::-webkit-scrollbar': {
          display: 'none',
        },
      },
    },
    wrapper: {
      display: 'grid',
      gridTemplateColumns: '1fr auto',
      gridTemplateRows: 'auto',
      gridTemplateAreas: "'slider aside' 'content content'",
      // replace with [BreakPointsMedia.SM], [BreakPointsMedia.XS], [BreakPointsMedia.XXS]{
      '@media screen and (max-width: 1024px)': {
        gridTemplateColumns: '1fr',
        gridTemplateAreas: "'slider' 'aside' 'content'",
      },
    },
    section: {
      minWidth: 0,
      minHeight: 0,
    },
    slider: {
      gridArea: 'slider',
      // replace with [BreakPointsMedia.SM], [BreakPointsMedia.XS], [BreakPointsMedia.XXS]{
      '@media screen and (max-width: 1024px)': {
        padding: 0,
      },
    },
    aside: {
      gridArea: 'aside',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      // replace with [BreakPointsMedia.SM], [BreakPointsMedia.XS], [BreakPointsMedia.XXS]{
      '@media screen and (max-width: 1280px)': {
        width: 'initial',
      },
      [isLeftToRight]: {
        paddingLeft: Spacings.s24,
        // replace with [BreakPointsMedia.MD], [BreakPointsMedia.SM], [BreakPointsMedia.XS], [BreakPointsMedia.XXS]{
        '@media screen and (max-width: 1280px)': {
          border: 'none',
        },
        '@media screen and (max-width: 1024px)': {
          padding: 0,
        },
      },
      [isRightToLeft]: {
        borderRight: `1px solid ${BackgroundColors.tint2}`,
        paddingRight: Spacings.s24,
        // replace with [BreakPointsMedia.MD], [BreakPointsMedia.SM], [BreakPointsMedia.XS], [BreakPointsMedia.XXS]{
        '@media screen and (max-width: 1280px)': {
          border: 'none',
          padding: 0,
        },
      },
    },
    content: {
      gridArea: 'content',
    },
    navigationWrapper: {
      marginBottom: Spacings.s4,
      display: 'flex',
      flexDirection: 'column',
      gap: Spacings.s12,
      '& > ul > li:first-child': {
        paddingLeft: 0,
      },
      // replace with [BreakPointsMedia.MD], [BreakPointsMedia.SM], [BreakPointsMedia.XS], [BreakPointsMedia.XXS]{
      '@media screen and (max-width: 1280px)': {
        padding: [0, Spacings.s12],
      },
    },
  },
  {
    name: 'single-template',
  },
);

export default useTemplateStyles;
